module.exports = __webpack_public_path__ + "static/media/2.fcb5f2f6.png";